import React from 'react';
import { cancelledredlabel, completedgreenlabel } from './CommonLabels';

export default function PostStatusLabel({ status }) {
  let statusLabel = "No Idea";
  let statusColor = "#000"; // default black

  // Determine label and color
  switch (status) {
    case 3:
    case 13:
    case 23:
      statusLabel = completedgreenlabel;
      break;
    case 4:
    case 14:
    case 24:
      statusLabel = cancelledredlabel;
      break;
    default:
      statusLabel = "No Idea";
      statusColor = "#000";
  }

  return (
    <>
      <p className='deadline-p' >
        {statusLabel}
      </p>
    </>
  );
}
